import React from 'react';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import ReactDOM from 'react-dom/client';
import NetworkError from './pages/network-error';
import { RecoilRoot } from 'recoil';
import {Route, Router, Switch } from 'react-router-dom';
import { createBrowserHistory } from 'history';

import * as Sentry from '@sentry/react';
import { initRemoteInput } from './services/RemoteInputService';

// Create Custom Sentry Route component
const SentryRoute = Sentry.withSentryRouting(Route);
const history = createBrowserHistory();
Sentry.init({
    dsn: "https://77df61c384b2778664aa9b0a3e23e4ec@o4507024258105344.ingest.us.sentry.io/4507033197805568",
    integrations: [
      Sentry.reactRouterV5BrowserTracingIntegration({ history }),
    ],
  
    // We recommend adjusting this value in production, or using tracesSampler
    // for finer control
    tracesSampleRate: 1.0,
  });

const originalConsole = { log: console.log, error: console.error}

// console.log = function(...args: any[]){
//     // Send log message to Sentry
//     const message = args.join(' ');
//     // Optionally, you can include additional information like severity level
//     // Sentry.captureMessage(message, Sentry.Severity.Info);
//     Sentry.captureMessage(message);
//     // Also, you can still log to the console if needed
//     originalConsole.log.apply(console, args);
//   };

console.error = function(...args: any[]){
    // Send error message to Sentry
    const message = args.join(' ');
    Sentry.captureException(message);
    // Also, you can still log to the console if needed
    originalConsole.error.apply(console, args);
};

// BLE remote input from the native app; register once before any page renders
initRemoteInput();

const root = ReactDOM.createRoot(document.getElementById('root')!);

root.render(
    // !(navigator.onLine) ?
    //     <NetworkError />
        <RecoilRoot><App /></RecoilRoot>
);
// ReactDOM.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>,

// );

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
